<template>
  <md-scroll-view
      ref="scrollView"
      :scrolling-x="false"
      :auto-reflow="true"
      @end-reached="onEndReached"
      class="my-scrollView"
  >
    <div class="app-list">
      <div class="app-item" v-for="(item, index) in handleList" :key="index" @click="goAppDetail(item)">
        <img class="app-img" v-lazy="item.pic" />
        <div class="app-name">{{ item.name }}</div>
      </div>
    </div>

    <no-data v-if="!handleList.length" />

    <!--        上拉加载更多组件-->
    <md-scroll-view-more
        slot="more"
        :is-finished="isFinished"
        :loading-text="$t('loading')"
        :finished-text="handleList.length ? $t('noMoreData') : ''"
    >
    </md-scroll-view-more>
  </md-scroll-view>
</template>

<script>
import NoData from '@/components/NoData/index';
import { getAppsList } from '@api/public';

export default {
  name: 'AppList',
  components: {
    NoData
  },
  data () {
    return {
      loading: false,
      isFinished: false,
      appList: [],
      currentPage: 1,
      total: 0,
      pageSize: 30,
      totalPageCount: 0
    };
  },
  computed: {
    ...mapGetters('publicStore', ['isH5']),
    handleList () {
      const list = this.appList.filter(i => i.is_window === 1);
      return list;
    }
  },
  mounted () {
    this.loading = true;
    this.appList = [];
    this.getList();
  },
  activated () {
    this.loading = true;
  },
  methods: {
    goAppDetail (item) {
      if (this.isH5) {
        // h5打开新窗口跳转
        this.jumpPath({ url: item.url, isNew: true });
      } else {
        this.jumpPath({ url: item.url });
      }
      this.$emit('onClose');
    },
    getList () {
      this.loading = true;
      getAppsList({ page: this.currentPage, pageSize: this.pageSize }).then(res => {
        if (res.result === 200000) {
          this.appList = this.appList.concat(res.data.list);
          this.total = res.data.count;
          // this.currentPage = res.data.list.page;
          this.totalPageCount = res.data.pageCount;
          if (this.currentPage >= this.totalPageCount) {
            this.isFinished = true;
          }
          this.loading = false;
          this.$refs.scrollView.finishLoadMore();
        }
      });
    },
    onEndReached () {
      if (this.isFinished || this.loading) return;
      console.log('onEndReached');
      this.currentPage += 1;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.my-scrollView {
  width: 100%;
  height: 100%;

  .app-list {
    display: flex;
    flex-wrap: wrap;

    .app-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 50px;
      margin-right: 22px;
      margin-bottom: 14px;

      &:nth-of-type(4n) {
        margin-right: 0;
      }

      .app-img {
        width: 50px;
        height: 50px;
        margin-bottom: 4px;
        border-radius: 8px;
      }

      .app-name {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 10px;
        line-height: 10px;
        letter-spacing: 0;
        color: #161616;
      }
    }
  }

  /deep/ .md-scroll-view-more {
    padding: 10px 0;
    font-size: 12px!important;
  }
}
</style>
